export default __webpack_public_path__ + "static/media/principios2.5a337754.png";